import React from "react";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnChiTiet } from "./ChucNang/ChiTiet/BtnChiTiet";
import { BtnSua } from "./ChucNang/SuaNguonVon/BtnSua";
import { BtnGopVon } from "./ChucNang/GopVon/BtnGopVon";
import { BtnRutVon } from "./ChucNang/RutVon/BtnRutVon";

export const ContentTable = ({
  listNguonVonFull,
  quyenGopVon,
  quyenRutVon,
  quyenSuaNguonVon,
  startIndex = 0,
}) => {
  return listNguonVonFull.map((item, index) => (
    <div className="custom-table-row">
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center ">{startIndex + index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-26 flex-basis-23-6-sm">
        <span className="mobile-column-name">Mã cổ đông</span>
        <div className="center-wrapper">
          <p className="text-center">
            <BtnChiTiet item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-17 flex-basis-19-sm">
        <span className="mobile-column-name">Cổ đông</span>
        <div className="center-wrapper">
          <p className="text-left word-break ">
            {item.FullName}
            <br />
            {item.SoDienThoai && <span>({item.SoDienThoai})</span>}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm ">
        <span className="mobile-column-name">Ngày</span>
        <div className="center-wrapper">
          <p className="text-center">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-12-8-sm">
        <span className="mobile-column-name">Số tiền</span>
        <div className="center-wrapper">
          <p className="text-right ">
            <p className="color-xanh"> {formatNumber(item.GiaTri)}</p>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Tỷ lệ vốn</span>
        <div className="center-wrapper">
          <p className="text-center">
            <span className="">{item.TiLe}%</span>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-8-6-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {quyenSuaNguonVon && <BtnSua item={item} />}
            {quyenGopVon && <BtnGopVon item={item} />}

            {quyenRutVon && <BtnRutVon item={item} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
